export const types = {
  customers: "[GET] Customers",
  addCustomers: "[POST] Customers",
  removeCustomers: "[DELETE] Customers",
  addCustomerWallets: "[POST] Wallets",
};
